<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="订单编号" prop="recycleNo">
        <el-input v-model="searchData.recycleNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单状态" prop="recycleStatusList">
        <el-select v-model="searchData.recycleStatusList" multiple placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in recycleStatusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="仓库编号" prop="stationId">
				<el-input v-model="searchData.stationId" placeholder="请输入" clearable></el-input>
			</el-form-item>
			<el-form-item label="仓库名称" prop="stationName">
				<el-input
					v-model="searchData.stationName"
					placeholder="请输入"
					clearable
				></el-input>
			</el-form-item> -->
      <el-form-item label="省" prop="provinceIds">
        <el-select v-model="searchData.provinceIds" multiple placeholder="请选择" clearable style="width: 100%" @change="provinceChangeFun">
          <el-option v-for="item in provinceListNew" :key="item.provinceId" :label="item.province" :value="item.provinceId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityIds">
        <el-select v-model="searchData.cityIds" multiple placeholder="请选择" clearable style="width: 100%" @change="cityChangeFun" :disabled="isCityDisabled">
          <el-option v-for="item in cityListNew" :key="item.cityId" :label="item.city" :value="item.cityId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区" prop="countyIds">
        <el-select v-model="searchData.countyIds" multiple placeholder="请选择" clearable style="width: 100%" :disabled="isDistrictDisabled">
          <el-option v-for="item in districtListNew" :key="item.countyId" :label="item.county" :value="item.countyId" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="联系人" prop="contactName">
				<el-input
					v-model="searchData.contactName"
					placeholder="请输入"
					style="width: 100%;"
					clearable
				></el-input>
			</el-form-item>
			<el-form-item label="联系人电话" prop="contactMobile">
				<el-input
					v-model="searchData.contactMobile"
					placeholder="请输入"
					style="width: 100%;"
					clearable
				></el-input>
			</el-form-item> -->

      <el-form-item label="承运商" prop="carrierNoList">
        <el-select multiple v-model="searchData.carrierNoList" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in partnershipList" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商所属组织" prop="carrierOrg">
        <el-input v-model="searchData.carrierOrg" placeholder="请输入" style="width: 100%;" clearable></el-input>
      </el-form-item>

      <el-form-item label="创建时间" prop="createdDate">
        <el-date-picker
          clearable
          v-model="searchData.createdDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="预约时间" prop="appointBeginDate">
        <el-date-picker
          clearable
          v-model="searchData.appointBeginDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="完成时间" prop="completeDate">
        <el-date-picker
          clearable
          v-model="searchData.completeDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" :loading="exportFlag" @click="exportFun">导出</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="searchFun">查询</el-button>
        <el-button size="medium" @click="resetFun">重置</el-button>
      </div>
    </div>
    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="操作" prop="action" width="180">
        <template slot-scope="scope">
          <el-row>
            <el-link type="primary" @click="rowDetailFun(scope.row)">查看</el-link>
            <el-link v-if="[100, 200, 300].includes(scope.row.recycleStatus)" style="margin-left: 8px;" type="primary" @click="dispatchRowFun(scope.row)">派车/改派</el-link>
            <el-link v-if="[100, 200, 300].includes(scope.row.recycleStatus)" style="margin-left: 8px;" type="primary" @click="cancelRowFun(scope.row)">取消</el-link>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column label="订单编号" prop="recycleNo" width="140"> </el-table-column>
      <el-table-column label="订单状态" prop="recycleStatusName" width="100"> </el-table-column>
      <!-- <el-table-column label="仓库编号" prop="stationId" width="140"> </el-table-column>
			<el-table-column label="仓库名称" prop="stationName" width="140"> </el-table-column> -->
      <el-table-column label="城市" prop="city" width="120"> </el-table-column>
      <el-table-column label="区/县" prop="county" width="120"> </el-table-column>

      <el-table-column label="下单旧机" prop="orderCount" width="120"> </el-table-column>
      <el-table-column label="实收旧机" prop="actualCount" width="120"> </el-table-column>
      <el-table-column label="承运商" prop="carrierName" width="140"> </el-table-column>
      <el-table-column label="承运商所属组织" prop="carrierOrg" width="140"> </el-table-column>
      <!-- <el-table-column label="联系人" prop="contactName" width="120"> </el-table-column>
			<el-table-column label="联系电话" prop="contactMobile" width="140"> </el-table-column>
			<el-table-column label="省" prop="province" width="100"> </el-table-column>
			<el-table-column label="市" prop="city" width="100"> </el-table-column>
			<el-table-column label="区" prop="county" width="100"> </el-table-column>
			<el-table-column label="详细地址" prop="address" width="160"> </el-table-column> -->
      <el-table-column label="创建时间" prop="createdDateStr" width="160"> </el-table-column>
      <el-table-column label="预约时间" prop="appointDateStr" width="160"> </el-table-column>
      <el-table-column label="完成时间" prop="completedDateStr" width="160"> </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <AssignVehiclesDialog ref="assignVehiclesDialogRef" @dispatch-success="searchFun"></AssignVehiclesDialog>
    <CancelConfirmDialog ref="cancelConfirmDialogRef" @confirm="confirmFun"></CancelConfirmDialog>
  </div>
</template>
<script>
import AssignVehiclesDialog from './components/AssignVehiclesDialog.vue'
import CancelConfirmDialog from './components/CancelConfirmDialog.vue'
import jdProvinceCity from './mixins/jdProvinceCity.js'
export default {
  components: {
    AssignVehiclesDialog,
    CancelConfirmDialog
  },
  mixins: [jdProvinceCity],
  data() {
    return {
      searchData: {
        recycleNo: undefined,
        recycleStatusList: undefined,
        stationId: undefined,
        stationName: undefined,
        provinceIds: undefined,
        cityIds: undefined,
        countyIds: undefined,
        contactName: undefined,
        contactMobile: undefined,
        carrierNoList: undefined,
        carrierOrg: undefined,
        createdDate: undefined,
        appointBeginDate: undefined,
        completeDate: undefined
      },
      recycleStatusList: [],
      partnershipList: [],
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        size: 10
      },
      total: 0,
      exportFlag: false
    }
  },
  computed: {
    // 添加计算属性来控制市和区的选择状态
    isCityDisabled() {
      // 当省份未选择或省份为多选时，禁用市选择器
      return !this.searchData.provinceIds || this.searchData.provinceIds.length === 0 || this.searchData.provinceIds.length > 1
    },
    isDistrictDisabled() {
      // 当市未选择、市为多选，或者省份为多选时，禁用区选择器
      return (
        !this.searchData.cityIds ||
        this.searchData.cityIds.length === 0 ||
        this.searchData.cityIds.length > 1 ||
        (this.searchData.provinceIds && this.searchData.provinceIds.length > 1)
      )
    }
  },
  created() {
    this.getEnumsMap()
    this.getCarrierListFun()
    this.searchFun()
    // 获取当前账号的组织类型
    this.partnershipType = JSON.parse(localStorage.getItem('partnershipType'))
  },
  methods: {
    searchFun() {
      this.pagination.page = 1
      this.getList()
    },
    resetFun() {
      this.searchData = {
        recycleNo: undefined,
        recycleStatusList: undefined,
        stationId: undefined,
        stationName: undefined,
        provinceIds: undefined,
        cityIds: undefined,
        countyIds: undefined,
        contactName: undefined,
        contactMobile: undefined,
        carrierNoList: undefined,
        carrierOrg: undefined,
        createdDate: undefined,
        appointBeginDate: undefined,
        completeDate: undefined
      }
      this.searchFun()
    },
    // 省改变
    provinceChangeFun() {
      this.searchData.cityIds = []
      this.searchData.countyIds = []
      // 当选择了省份时，清空市区数据
      if (this.searchData.provinceIds && this.searchData.provinceIds.length > 0) {
        // 如果选择了多个省份，则不加载城市数据
        if (this.searchData.provinceIds.length === 1) {
          this.getTblCityNew(this.searchData.provinceIds[0])
        } else {
          // 多选省份时清空城市和区县选项
          this.cityListNew = []
          this.districtListNew = []
        }
      } else {
        // 未选择省份时清空城市和区县选项
        this.cityListNew = []
        this.districtListNew = []
      }
    },
    // 市改变
    cityChangeFun() {
      this.searchData.countyIds = []
      // 当选择了城市时，只有当选择单个城市时才加载区县数据
      if (this.searchData.cityIds && this.searchData.cityIds.length > 0) {
        if (this.searchData.cityIds.length === 1 && this.searchData.provinceIds && this.searchData.provinceIds.length === 1) {
          this.getTblCountyNew(this.searchData.provinceIds[0], this.searchData.cityIds[0])
        } else {
          // 多选城市时清空区县选项
          this.districtListNew = []
        }
      } else {
        // 未选择城市时清空区县选项
        this.districtListNew = []
      }
    },
    // 取消
    cancelRowFun(rowData) {
      this.cancelRecycleNo = rowData.recycleNo
      this.$refs.cancelConfirmDialogRef.opendDialog()
    },
    // 确认取消
    confirmFun() {
      const url = `/autoapp-default-server-recovery/api/jd/recycle/cancelRecycle/${this.cancelRecycleNo}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          this.$message.success('取消成功')
          this.searchFun()
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 查看
    rowDetailFun(rowData) {
      const recycleNo = rowData.recycleNo
      // 在新标签页中打开详情页面
      const routeData = this.$router.resolve({
        path: '/jdOldMachineRecycleManage/recycleOrderDetail',
        query: {
          recycleNo
        }
      })
      window.open(routeData.href, '_blank')
    },
    // 派工改派
    dispatchRowFun(rowData) {
      // console.log('====rowData===', rowData)
      this.$refs.assignVehiclesDialogRef.opendDialog(rowData)
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    getList() {
      this.tableLoading = true
      const url = '/autoapp-default-server-recovery/api/jd/recycle/pageCondition'
      const { createdDate = [], appointBeginDate = [], completeDate = [] } = this.searchData
      const startCreatedDate = createdDate.length > 0 ? `${createdDate[0]} 00:00:00` : undefined
      const endCreatedDate = createdDate.length > 0 ? `${createdDate[1]} 23:59:59` : undefined
      const startAppointBeginDate = appointBeginDate.length > 0 ? `${appointBeginDate[0]} 00:00:00` : undefined
      const endAppointBeginDate = appointBeginDate.length > 0 ? `${appointBeginDate[1]} 23:59:59` : undefined
      const startCompleteDate = completeDate.length > 0 ? `${completeDate[0]} 00:00:00` : undefined
      const endCompletedDate = completeDate.length > 0 ? `${completeDate[1]} 23:59:59` : undefined
      const params = {
        ...this.searchData,
        // 处理多选参数
        provinceIds: this.searchData.provinceIds || undefined,
        cityIds: this.searchData.cityIds || undefined,
        countyIds: this.searchData.countyIds || undefined,
        startCreatedDate,
        endCreatedDate,
        startAppointBeginDate,
        endAppointBeginDate,
        startCompleteDate,
        endCompletedDate,
        ...this.pagination
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          const resData = res.data || []
          this.total = res.total || 0
          this.tableData = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
        this.tableLoading = false
      })
    },
    // 获取承运商列表
    getCarrierListFun() {
      const url = '/autoapp-default-server-recovery/api/jd/partnerManagementBond/pageJdPartnerShip'
      const params = {
        currPage: 1,
        pageSize: 999999
      }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          this.partnershipList = res.data || []
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 获取订单状态
    getEnumsMap() {
      const url = '/autoapp-default-server-recovery/api/jd/recycle/common/getRecycleStatusMap'
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          const itemObj = res.data
          const listData = Object.entries(itemObj).map(([value, label]) => ({ label, value }))
          this.recycleStatusList = listData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 导出
    exportFun() {
      this.exportFlag = true
      setTimeout(() => {
        this.exportFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/jd/recycle/export/pageCondition'
      const title = '京东旧机回收订单'
      const { createdDate = [], appointBeginDate = [], completeDate = [] } = this.searchData
      const startCreatedDate = createdDate.length > 0 ? `${createdDate[0]} 00:00:00` : undefined
      const endCreatedDate = createdDate.length > 0 ? `${createdDate[1]} 23:59:59` : undefined
      const startAppointBeginDate = appointBeginDate.length > 0 ? `${appointBeginDate[0]} 00:00:00` : undefined
      const endAppointBeginDate = appointBeginDate.length > 0 ? `${appointBeginDate[1]} 23:59:59` : undefined
      const startCompleteDate = completeDate.length > 0 ? `${completeDate[0]} 00:00:00` : undefined
      const endCompletedDate = completeDate.length > 0 ? `${completeDate[1]} 23:59:59` : undefined
      const params = {
        ...this.searchData,
        // 处理多选参数
        provinceIds: this.searchData.provinceIds || undefined,
        cityIds: this.searchData.cityIds || undefined,
        countyIds: this.searchData.countyIds || undefined,
        startCreatedDate,
        endCreatedDate,
        startAppointBeginDate,
        endAppointBeginDate,
        startCompleteDate,
        endCompletedDate,
        ...this.pagination
      }
      // this.global.exportExcel(url, params, title).catch((res) => {
      // 	let blob = new Blob([res.response.data], {
      // 		type: "application/json",
      // 	})
      // 	var blobReader = new Response(blob).json()
      // 	blobReader.then((res) => {
      // 		this.$message.error(res.message)
      // 	})
      // })

      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/jdOldMachineRecycleOrder.vue